export default "__VITE_ASSET__BmHtIJxl__"